import React, { ReactElement } from 'react';
import { WorkerChangeTabProps } from 'containers/entityChange/worker/types';

export function WorkerAccessEvents(props: WorkerChangeTabProps): ReactElement {
  const { loading, worker, onTabApiChange } = props; // eslint-disable-line unused-imports/no-unused-vars

  // get worker jobsites changes

  // React.useEffect(() => onTabApiChange({ refetchData: refetchWorkerData }), [refetchWorkerData]);

  return <div>Worker Access Events Changes</div>;
}
